import { API } from "../urls";

// Cookie-based auth: credentials: 'include' ile access_token cookie otomatik gönderilir
const getHeaders = () => ({
    "Content-Type": "application/json",
});

// Dosya yüklemede Content-Type tarayıcı tarafından (boundary ile) otomatik set edilir
const getFileHeaders = () => ({});

const fetchOpts = { credentials: 'include' };

// Firmaları getirs
export const fetchCompaniesNames = async () => {
    const res = await fetch(API.get_companies_names, { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

// Grupları getir
export const fetchGroupsByCompany = async (companyId) => {
    const res = await fetch(API.groups_by_company(companyId), { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

// Yeni Cari Oluştur
export const createAccount = async (payload) => {
    const res = await fetch(API.create_account, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Oluşturma başarısız");
    }
    return res.json();
};

// Excel Import
export const importAccountsFromExcel = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(`${API.import_excel}`, {
        method: "POST",
        ...fetchOpts,
        headers: getFileHeaders(),
        body: formData,
    });

    if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Excel yükleme başarısız");
    }
    return res.json();
};

// Benim carilerim
export const fetchAccountsMe = async () => {
    const res = await fetch(API.accounts_me, { ...fetchOpts, headers: getHeaders() });
    return res;
};

// Bir taksit grubuna bağlı cariler (salt okunur liste, sayfalı)
export const fetchAccountsByGroup = async ({ groupId, page = 0, size = 10, searchTerm = "" }) => {
    const params = new URLSearchParams({
        accountGroupId: groupId,
        page: String(page),
        size: String(size),
    });
    if (searchTerm) params.set("searchTerm", searchTerm);

    const res = await fetch(`${API.accounts_list}?${params.toString()}`, {
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || "Bağlı cariler yüklenemedi");
    }
    return res.json();
};

// Cari özet bilgisi
export const fetchAccountSummary = async (accountId) => {
    const res = await fetch(API.account_summary(accountId), { ...fetchOpts, headers: getHeaders() });
    return res;
};
